// src/finance/timeline.ts
// Déclinaison du CA mensuel cible en paliers heure/jour/semaine (bande du Calculateur).
// Semaine = calendaire moyenne (× 12 ÷ 52) : les 4 paliers décrivent le même flux annuel.
import { round2 } from './engine/tax'

export type RevenueTimelineValues = {
  /** null si billableDays ou hoursPerDay ≤ 0 (palier sans sens, affiché « — »). */
  hourly: number | null
  /** null si billableDays ≤ 0. */
  daily: number | null
  weekly: number
  monthly: number
}

export function revenueTimeline(
  revenueMonthly: number,
  billableDays: number,
  hoursPerDay: number,
): RevenueTimelineValues {
  return {
    hourly:
      billableDays > 0 && hoursPerDay > 0
        ? round2(revenueMonthly / billableDays / hoursPerDay)
        : null,
    daily: billableDays > 0 ? round2(revenueMonthly / billableDays) : null,
    weekly: round2((revenueMonthly * 12) / 52),
    monthly: round2(revenueMonthly),
  }
}
